import script from "./DetalharEntrada.vue?vue&type=script&setup=true&lang=js"
export * from "./DetalharEntrada.vue?vue&type=script&setup=true&lang=js"

import "./DetalharEntrada.vue?vue&type=style&index=0&id=1ec3f249&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ec3f249"]])

export default __exports__